import { supertypeClass } from '@haventech/amorphic';
import { Customer } from './Customer';

@supertypeClass({ toClient: false, toServer: false })
export class CustomerUtils {
  public static hasPrimaryAdvisor(customer: Customer): boolean {
    return (
      !!customer.application &&
      !!customer.application.primaryPolicy &&
      !!customer.application.primaryPolicy.servicingAgent
    );
  }

  public static async customerWithEmailExists(email: string): Promise<boolean> {
    let customerExists: boolean = false;

    if (email) {
      const customers: Array<Customer> = await Customer.getFromPersistWithQuery({
        email: {
          $regex: new RegExp('^' + email.toLowerCase().replace(/([^0-9a-zA-Z])/g, '\\$1') + '$'),
          $options: 'i',
        },
      });

      if (customers && customers.length > 0) {
        customerExists = true;
      }
    }

    return customerExists;
  }

  public static formatSSN(value: string): string {
    if (!value) {
      return '';
    }

    const strippedValue = value.replace(/[^0-9]/g, '');

    if (strippedValue.length === 9) {
      const ssnBuffer = [];

      for (let i = 0; i < strippedValue.length; i++) {
        switch (i) {
          case 3:
            ssnBuffer.push('-');
            ssnBuffer.push(strippedValue[i]);
            break;
          case 5:
            ssnBuffer.push('-');
            ssnBuffer.push(strippedValue[i]);
            break;
          default:
            ssnBuffer.push(strippedValue[i]);
            break;
        }
      }
      return ssnBuffer.join('');
    } else {
      return value;
    }
  }
}
